import { render, staticRenderFns } from "./FolderDelete.vue?vue&type=template&id=e1784174"
import script from "./FolderDelete.vue?vue&type=script&lang=js"
export * from "./FolderDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports